import { defineMessages } from 'react-intl';

const trns = defineMessages({
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  catalogBreadCrumb: {
    id: '/gLOfj',
    defaultMessage: 'Каталог'
  }
});

export default trns;
